function MHCError(code = 0, message = null, title = null) {
    this.code = code;
    this.message = message;
    this.title = title;
}

MHCError.prototype.setResponse = function(response, title = null) {
    this.code = response.status;
    try {
        this.message = response.headers.get('Message');
    } catch ( ex ) {
        this.message = response.headers.Message
    }

    this.title = title;

    const FETCH_EXCEPTION_ERROR_MSG = 'Sorry, there seems to be an issue with the network. Please try again later.'

    // ltria API error or rainbow api (JW) error
    try {
        if (this.message == null) {
            if (response.headers.get('content-type').includes('application/json')) {
                return response.json().then(json => {
                    if (json['error']) {
                        this.message = json['error']
                    }
                    var errorList = []
                    if (json['errorMessage']) {
                        errorList = json['errorMessage'].split(",")
                        if (errorList[0].startsWith('Validation Error')) {
                            this.message = errorList[2];
                            this.title = errorList[0];
                        } else {
                            this.message = json['errorMessage'];
                        }
                    }

                    if (this.message == null) {
                        this.message = FETCH_EXCEPTION_ERROR_MSG
                    // if (this.code == 400) {
                    //     this.message = '400 Bad Request';
                    // } else if (this.code == 401) {
                    //     this.message = '401 Unauthorized';
                    // } else if (this.code == 403) {
                    //     this.message = '403 Forbidden';
                    // } else if (this.code == 404) {
                    //     this.message = '404 Not Found';
                    // } else if (this.code == 409) {
                    //     this.message = '409 Conflict';
                    // } else if (this.code == 500) {
                    //     this.message = '500 Internal Server Error';
                    // } else if (this.code == 503) {
                    //     this.message = '503 Service Unavailable';
                    // } else {
                    //     this.message = 'Error code ' + this.code;
                    // }
                    }
                });
            } else if (response.headers.get('content-type').includes('text/plain')) {
                return response.text().then(text => {
                    if (text) {
                        this.message = text;
                    } else {
                        this.message = FETCH_EXCEPTION_ERROR_MSG
                    // if (this.code == 400) {
                    //     this.message = '400 Bad Request';
                    // } else if (this.code == 401) {
                    //     this.message = '401 Unauthorized';
                    // } else if (this.code == 403) {
                    //     this.message = '403 Forbidden';
                    // } else if (this.code == 404) {
                    //     this.message = '404 Not Found';
                    // } else if (this.code == 409) {
                    //     this.message = '409 Conflict';
                    // } else if (this.code == 500) {
                    //     this.message = '500 Internal Server Error';
                    // } else if (this.code == 503) {
                    //     this.message = '503 Service Unavailable';
                    // } else {
                    //     this.message = 'Error code ' + this.code;
                    // }
                    }
                });
            }
        }
    } catch ( ex ) {}

    if (this.message == null) {
        this.message = FETCH_EXCEPTION_ERROR_MSG
    // if (this.code == 400) {
    //     this.message = '400 Bad Request';
    // } else if (this.code == 401) {
    //     this.message = '401 Unauthorized';
    // } else if (this.code == 403) {
    //     this.message = '403 Forbidden';
    // } else if (this.code == 404) {
    //     this.message = '404 Not Found';
    // } else if (this.code == 409) {
    //     this.message = '409 Conflict';
    // } else if (this.code == 500) {
    //     this.message = '500 Internal Server Error';
    // } else if (this.code == 503) {
    //     this.message = '503 Service Unavailable';
    // } else {
    //     this.message = 'Error code ' + this.code;
    // }
    }

    return new Promise((resolve, reject) => {
        resolve();
    });
};

export default MHCError;